import { EventsManager } from '@game-libs/events-manager';
import { AudioManager } from '@game-libs/audio-manager';
import { Engine } from 'excalibur';
import { PlayerEvents } from '@game-libs/models';
import { GameplayEvents } from '../types/game-events';

export const initGameEventsListeners = (game: Engine) => {
  const { playSFX } = AudioManager();
  const { on } = EventsManager();

  on(GameplayEvents.DRAGON_ROAR, () => {
    playSFX('roar_1', 1.2);
  });

  on(GameplayEvents.DRAGON_GRUNT, () => {
    playSFX('roar_3', 1);
  });

  on(PlayerEvents.UNLOCK_ITEM, () => {
    // playSFXNow('unlock', 0.8);
  });
};
